import axios from 'axios';
import config from '../config/apiConfig';

export const getTheme = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${config.api_url}/api/theme/`, { headers: { 'token': token } });
};

// Valores por defecto para los estilos de la tienda
export const ESTILOS_DEFAULT = {
    pedidos_web: {
        color_primario: '#0066FF',
        color_secundario: '#6C757D',
        color_fondo: '#f4f7f6',
        color_texto: '#1a1c1d',
        color_btn_primario: '#000000',
        color_btn_texto: '#ffffff',
        btn_continuar_bg: '#198754',
        btn_continuar_texto: '#ffffff',
        categoria_activa_bg: '#000000',
        categoria_activa_texto: '#ffffff',
        categoria_inactiva_bg: '#f1f3f5',
        categoria_inactiva_texto: '#495057',
        fuente: "'Inter', sans-serif",
        border_radius_general: '12px'
    },
    carta_qr: {
        color_primario: '#F26B21',
        color_secundario: '#6C757D',
        color_fondo: '#f4f7f6',
        header_bg: '#F26B21',
        header_text_color: '#FFFFFF',
        footer_bg: '#1a1c1d',
        footer_text_color: '#FFFFFF',
        logo_tamano: 'mediano',
        tarjeta_radio: 'redondeado',
        tarjeta_sombra: false,
        mostrar_precios: true,
        bienvenida: ''
    }
};

// Obtener estilos de tienda (admin - requiere token)
export const obtenerEstilosAdmin = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${config.api_url}/api/estilos-tienda`, {
            headers: { 'token': token }
        });
        // Si la respuesta tiene datos, los retornamos; si no, los valores por defecto
        if (res.data) {
            // Asegurar que pedidos_web exista
            if (!res.data.pedidos_web) {
                res.data.pedidos_web = { ...ESTILOS_DEFAULT.pedidos_web };
            }
            return res.data;
        }
        return { ...ESTILOS_DEFAULT };
    } catch (error) {
        console.error("Error al obtener estilos:", error);
        return { ...ESTILOS_DEFAULT };
    }
};

// Guardar estilos de tienda (admin - requiere token)
export const guardarEstilos = async (estilos) => {
    try {
        const token = localStorage.getItem('token');
        const res = await axios.post(`${config.api_url}/api/estilos-tienda`, estilos, {
            headers: { 'token': token, 'Content-Type': 'application/json' }
        });
        return res.data;
    } catch (error) {
        console.error("Error al guardar estilos:", error);
        if (error.response && error.response.data) {
            return error.response.data;
        }
        return { status: 'error', message: 'Error de conexión al guardar estilos' };
    }
};

// Obtener estilos de tienda por slug (público - sin token)
export const obtenerEstilosTienda = async (slug) => {
    try {
        const res = await axios.get(`${config.api_url}/api/configuracion/estilos-publicos/${slug}`);
        if (res.data) {
            if (!res.data.pedidos_web) {
                res.data.pedidos_web = { ...ESTILOS_DEFAULT.pedidos_web };
            }
            return res.data;
        }
        return { ...ESTILOS_DEFAULT };
    } catch (error) {
        console.error("Error al obtener estilos de tienda:", error);
        return { ...ESTILOS_DEFAULT };
    }
};

// Aplicar estilos al DOM
export const aplicarEstilos = (estilos, seccion = 'pedidos_web') => {
    const estilosSeccion = estilos && estilos[seccion] ? estilos[seccion] : estilos || {};
    if (!estilosSeccion || Object.keys(estilosSeccion).length === 0) return;

    const root = document.documentElement;

    // Mapeo de nombres de campo a variables CSS
    const mapeoCSS = {
        color_primario: '--color-primario',
        color_secundario: '--color-secundario',
        color_fondo: '--color-fondo',
        color_texto: '--color-texto',
        color_btn_primario: '--color-btn-primario',
        color_btn_texto: '--color-btn-texto',
        btn_continuar_bg: '--btn-continuar-bg',
        btn_continuar_texto: '--btn-continuar-texto',
        categoria_activa_bg: '--categoria-activa-bg',
        categoria_activa_texto: '--categoria-activa-texto',
        categoria_inactiva_bg: '--categoria-inactiva-bg',
        categoria_inactiva_texto: '--categoria-inactiva-texto',
        fuente: '--fuente-general',
        border_radius_general: '--border-radius-general',
        url_logo: '--url-logo'
    };

    Object.entries(mapeoCSS).forEach(([campo, variable]) => {
        if (estilosSeccion[campo] !== undefined && estilosSeccion[campo] !== null) {
            root.style.setProperty(variable, estilosSeccion[campo]);
        }
    });

    // Aplicar fuente si existe
    if (estilosSeccion.fuente) {
        document.body.style.fontFamily = estilosSeccion.fuente;
    }
};
